var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.17567 15.7784C2.90397 16.07 2.91199 16.5244 3.1938 16.8062C3.47561 17.088 3.92999 17.096 4.22157 16.8243L11.9771 8.93072L19.7325 16.8243C20.0241 17.096 20.4785 17.088 20.7603 16.8062C21.0421 16.5244 21.0501 16.07 20.7784 15.7784L11.9771 6.97705L3.17567 15.7784Z",
    fill: "#160259"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.641e69dd492606e8e3153bb0e4294ad5.svg";
export { ForwardRef as ReactComponent };